import getBrowserLanguage from './getBrowserLanguage';
import { load } from '@progress/kendo-react-intl';
import axios from 'axios';

import weekData from 'cldr-core/supplemental/weekData.json';
import enNumbers from 'cldr-numbers-full/main/en/numbers.json';
import enLocalCurrency from 'cldr-numbers-full/main/en/currencies.json';
import enCaGregorian from 'cldr-dates-full/main/en/ca-gregorian.json';
import enDateFields from 'cldr-dates-full/main/en/dateFields.json';

const _fetchFormats = (lang: string) => {
  return Promise.all([
    axios(`/cldr-numbers-full/main/${lang}/numbers.json`),
    axios(`/cldr-numbers-full/main/${lang}/currencies.json`),
    axios(`/cldr-dates-full/main/${lang}/ca-gregorian.json`),
    axios(`/cldr-dates-full/main/${lang}/dateFields.json`),
  ]);
};

const _loadFormats = (formats, lang) => {
  formats.forEach((item) => load(item.data));
  load(weekData);
  return lang;
};

const initLanguage = () => {
  const defaultLang: string = 'en-US';
  const lang: string = getBrowserLanguage() || defaultLang;
  const subTag: string = lang.substring(0, 2);

  return _fetchFormats(lang)
    .then((data) => {
      _loadFormats(data, lang);
      return lang;
    })
    .catch((err) => {
      console.log(lang, 'Error loading locale settings', err.message);
      return _fetchFormats(subTag)
        .then((data) => {
          _loadFormats(data, subTag);
          return subTag;
        })
        .catch((err) => {
          console.log(subTag, 'Error loading locale settings', err);
          load(enNumbers, enLocalCurrency, enCaGregorian, enDateFields, weekData);
          return defaultLang;
        });
    });
};

export default initLanguage;
